"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIcon = void 0;
var react_1 = __importDefault(require("react"));
var loading_style_1 = __importDefault(require("./loading.style"));
var LoadingIcon = function () {
    var classes = (0, loading_style_1.default)();
    return (react_1.default.createElement("div", { className: classes.circleProgress },
        react_1.default.createElement("svg", { className: classes.circleProgressSvg, viewBox: "22 22 44 44" },
            react_1.default.createElement("circle", { className: classes.circleProgressCircle, cx: 44, cy: 44, r: 19.5, style: { fill: 'none', strokeWidth: 5 } }))));
};
exports.LoadingIcon = LoadingIcon;
//# sourceMappingURL=Loading.js.map